import React, { useRef, useState, useEffect } from "react";
import { Bold, Italic, List, ListOrdered, Heading2, Heading3, Link2, Code, Eye } from "lucide-react";

export default function RichEditor({ value, onChange, placeholder = "Съдържание..." }) {
  const ref = useRef(null);
  const [mode, setMode] = useState("visual");

  useEffect(() => {
    if (mode === "visual" && ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [mode]); // eslint-disable-line

  const exec = (cmd, arg) => { document.execCommand(cmd, false, arg); ref.current?.focus(); sync(); };
  const sync = () => onChange(ref.current?.innerHTML || "");
  const link = () => { const url = window.prompt("URL:"); if (url) exec("createLink", url); };

  const Tool = ({ icon: Icon, cmd, arg, action, title }) => (
    <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); action ? action() : exec(cmd, arg); }}
            className="w-8 h-8 flex items-center justify-center text-navy hover:bg-stone rounded">
      <Icon size={16} />
    </button>
  );

  return (
    <div className="border border-stone">
      <div className="flex items-center gap-1 border-b border-stone bg-ivory px-2 py-1.5 flex-wrap">
        <button type="button" onClick={() => setMode("visual")} className={`flex items-center gap-1 px-2 py-1 text-xs rounded ${mode === "visual" ? "bg-navy text-white" : "text-navy"}`}><Eye size={13} /> Визуален</button>
        <button type="button" onClick={() => setMode("code")} className={`flex items-center gap-1 px-2 py-1 text-xs rounded ${mode === "code" ? "bg-navy text-white" : "text-navy"}`}><Code size={13} /> Код</button>
        {mode === "visual" && <>
          <span className="w-px h-5 bg-stone mx-1" />
          <Tool icon={Heading2} cmd="formatBlock" arg="h2" title="Заглавие" />
          <Tool icon={Heading3} cmd="formatBlock" arg="h3" title="Подзаглавие" />
          <Tool icon={Bold} cmd="bold" title="Удебелен" />
          <Tool icon={Italic} cmd="italic" title="Наклонен" />
          <Tool icon={List} cmd="insertUnorderedList" title="Списък" />
          <Tool icon={ListOrdered} cmd="insertOrderedList" title="Номериран" />
          <Tool icon={Link2} action={link} title="Връзка" />
        </>}
      </div>
      {mode === "visual" ? (
        <div ref={ref} contentEditable suppressContentEditableWarning onInput={sync}
             className="rich-content min-h-[220px] p-4 outline-none text-charcoal/85" data-placeholder={placeholder} />
      ) : (
        <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={12}
                  className="w-full p-4 outline-none font-mono text-sm text-charcoal/85" placeholder="<p>HTML код...</p>" />
      )}
    </div>
  );
}
